import { useState } from 'react'
import { Sizes, UploadFileProps } from '../../types'
import getImageResolution from 'helpers/image/getImageResolution'
import { toast } from '@wellesley/system-toast'
import { useSelector } from 'react-redux'
import { platformSettingsSlice } from '@wellesley/settings/slices/platformSettingsSlice'

import { logger } from 'helpers/logger'
import { useUploadFile } from '../useUploadFile'

const useImageSelection = (onSave: (props: UploadFileProps[]) => void) => {
  const extensions = useSelector(
    platformSettingsSlice.selectors.selectImageExtensions,
  )

  const [uploadFile] = useUploadFile()

  const acceptList = (extensions || []).map((e: string) => `.${e}`).join()

  const [sizes, setSizes] = useState<Sizes>({
    width: 0,
    height: 0,
  })

  const [preview, setPreview] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleFileChange = async (props: UploadFileProps[]) => {
    try {
      const [media] = props
      const resolution = await getImageResolution(media.file)
      resolution && setSizes(resolution)
      setPreview(media.objectUrl)
    } catch (e) {
      toast.error('Upload image error')
      logger.error(`Upload image error: ${e as string}`)
    }
  }

  const handleUpload = (props: UploadFileProps[]) => {
    void handleFileChange(props)
    setIsModalOpen(true)
  }

  const resetAndClose = () => {
    setIsModalOpen(false)
    setPreview('')
  }

  const handleSave = (props: UploadFileProps[]) => {
    void onSave?.(props)
    resetAndClose()
  }

  return {
    sizes,
    preview,
    acceptList,
    isModalOpen,
    uploadFile,
    handleSave,
    handleClose: resetAndClose,
    handleUpload,
    handleFileChange,
  }
}

export default useImageSelection
